export default () => {
  if (process.client) {
    const script = document.createElement('script')
    script.src = 'https://unpkg.com/@splinetool/viewer'
    script.type = 'module'
    script.async = true
    document.head.appendChild(script)
  }
}
